import React from 'react'
import Swal from 'sweetalert2'
import '../style.css'
import { renderToString } from 'react-dom/server'
import i18n from 'sharedKernel/i18n/translate/config'
import { InputField, PopUpContainer, PopUpContent, PopUpHeader, PopUpTitle } from './style'

export interface EditTitleModalProps {
  currentTitle: string
  onConfirm: (newTitle: string) => void
  onCancel?: () => void
}

const getTitleInput = (): HTMLInputElement | null => {
  return document.getElementById('title-input') as HTMLInputElement | null
}

export const editTitleModal = ({ currentTitle, onConfirm, onCancel }: EditTitleModalProps): void => {
  const labels = {
    title: i18n.t('solution.title.editModal.title'),
    placeholder: i18n.t('solution.title.editModal.placeholder'),
    confirm: i18n.t('Confirm'),
    cancel: i18n.t('Cancel'),
    emptyValidation: i18n.t('solution.title.editModal.emptyValidation')
  }

  const content = (
    <PopUpContainer>
      <PopUpHeader>
        <PopUpTitle>{labels.title}</PopUpTitle>
      </PopUpHeader>
      <PopUpContent>
        <InputField
          id="title-input"
          defaultValue={currentTitle}
          placeholder={labels.placeholder}
        />
      </PopUpContent>
    </PopUpContainer>
  )

  Swal.fire({
    showCloseButton: true,
    confirmButtonText: labels.confirm,
    allowOutsideClick: true,
    showCancelButton: true,
    cancelButtonText: labels.cancel,
    customClass: {
      popup: 'edit-title-popup',
      confirmButton: 'edit-title-confirm',
      cancelButton: 'edit-title-cancel'
    },
    html: renderToString(content),
    width: '500px',
    heightAuto: false,
    padding: 0,
    backdrop: 'rgba(0,0,0,0.4)',
    didOpen: () => {
      getTitleInput()?.focus()
    },
    preConfirm: () => {
      const newTitle = getTitleInput()?.value?.trim()

      if (newTitle === '' || newTitle === undefined) {
        Swal.showValidationMessage(labels.emptyValidation)
        return false
      }

      return newTitle
    }
  }).then((result) => {
    if (result.isConfirmed && result.value !== undefined && result.value !== '') {
      onConfirm(result.value)
      return
    }

    if (
      result.isDismissed &&
      result.dismiss === Swal.DismissReason.cancel &&
      typeof onCancel === 'function'
    ) {
      onCancel()
    }
  })
}